import React, { useState } from "react";
import { t } from "../../../../../utils/i18n";

const TradeId = ({ tradeData }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (text) => {
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };

  return (
    <div>
      <p className="tradeDetails-tradeId">
        <span>{t("p2p.trade_id.label")}</span>
        <span className="tradeDetails-tradeId-number">{tradeData?.id}</span>
        <button onClick={() => handleCopy(tradeData.id)} className="tradedetails-copybtn">
          <i className={`fas fa-${copied ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
        </button>
      </p>
    </div>
  );
};

export default TradeId;
